class CollapsibleContent {
    constructor() {
      this.init();
    }
  
    init() {
      const accordions = document.querySelectorAll('.accordion details');
      
      accordions.forEach(details => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.accordion__content');
        
        if (!summary || !content) return;
  
        // Remove any existing event listeners to prevent duplicates
        summary.removeEventListener('click', this.handleClick);
        
        // Set initial state
        if (!details.hasAttribute('open')) {
          content.style.height = '0px';
          content.style.overflow = 'hidden';
          content.style.opacity = '0';
        } else {
          content.style.height = 'auto';
          content.style.overflow = 'visible';
          content.style.opacity = '1';
        }
  
        // Handle click events
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleAccordion(details, content);
        });
      });
    }
  
    toggleAccordion(details, content) {
      const isOpen = details.hasAttribute('open');
      
      if (isOpen) {
        // Closing animation
        const currentHeight = content.scrollHeight;
        
        // Set current height first
        content.style.height = currentHeight + 'px';
        content.style.overflow = 'hidden';
        
        // Force reflow to ensure height is set
        requestAnimationFrame(() => {
          content.style.height = '0px';
          content.style.opacity = '0';
          
          // Remove open attribute after animation starts
          setTimeout(() => {
            details.removeAttribute('open');
          }, 300);
        });
        
      } else {
        // Opening animation
        details.setAttribute('open', '');
        
        // Get the natural height
        const targetHeight = content.scrollHeight;
        
        // Start from 0 height
        content.style.height = '0px';
        content.style.overflow = 'hidden';
        content.style.opacity = '0';
        
        // Animate to target height
        requestAnimationFrame(() => {
          content.style.height = targetHeight + 'px';
          content.style.opacity = '1';
          
          // Reset to auto after animation completes
          setTimeout(() => {
            content.style.height = 'auto';
            content.style.overflow = 'visible';
          }, 300);
        });
      }
    }
  }
  
  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new CollapsibleContent();
  });
  
  // Re-initialize for dynamic content (e.g., AJAX loaded sections)
  document.addEventListener('shopify:section:load', () => {
    new CollapsibleContent();
  }); 